import { type Form, type FormField } from '@wix/ambassador-forms-v4-form/types';
import { type PossibleValues, EMPTY_VALUE } from '@wix/form-fields';
import { type FormValues } from '../types';

export const fillEmptyValues = (
  form?: Form,
  values?: FormValues,
  recursive = true,
) => {
  if (!form?.fields) {
    return {};
  }

  return form.fields.reduce((result: FormValues, field: FormField) => {
    const fieldTarget = field.target;
    if (!fieldTarget) {
      return result;
    }

    const fieldValue = values?.[fieldTarget];
    const defaultValue = field.view?.defaultValue;
    const fieldType = field.view?.fieldType;
    const nestedForm = field.view?.form;

    if (recursive && nestedForm) {
      result[fieldTarget] = fillEmptyValues(
        nestedForm,
        fieldValue as FormValues,
        false,
      ) as PossibleValues;
    } else if (fieldValue !== undefined) {
      result[fieldTarget] = fieldValue;
    } else if (defaultValue !== undefined) {
      result[fieldTarget] = defaultValue;
    } else if (fieldType) {
      result[fieldTarget] = EMPTY_VALUE;
    }

    return result;
  }, {});
};
